export const relatorio = ({
    dtInicio : null,
    dtFim: null,
    idLocal : null,
    locais: null,
    nomeRelatorio: null,
    locaisStr: null,
    itens: null
  })
